/**
 * * Модель родительской задачи
 */
export class TaskParentModel {
  /**ID задачи */
  Id!: number;
  /**Название задачи */
  Name!: string;
  /**ID проекта */
  ProjectId!: number;
  /**ID неймспейса */
  NamespaceId!: string;
  /**ID очереди */
  QueueId!: string;
  /**Доступ к род. задаче */
  HasAccessToParentTask!: boolean;

  constructor(obj?: Partial<TaskParentModel>) {
    Object.assign(this, obj);
  }
}
